import type { ICategory, IFindGamesOptions } from "../types"
import { computed } from "vue"
import { useBetStore } from "../../../../store"

export function useIsMobile() {
  const store = useBetStore()

  return computed(() => store.getScreenWidth < 512)
}

export function findGamesInCategory(categories: ICategory[], options: IFindGamesOptions = {}) {
  const { search = "", categoryId = null } = options

  const category = categories.find(cat => cat.id === categoryId)

  if (!category || !category.games) {
    return []
  }

  if (!search) {
    return category.games
  }

  return category.games.filter(game =>
    game.name.toLowerCase().includes(search.toLowerCase()),
  )
}
